import isUndefined from 'lodash/isUndefined'
import groupBy from 'lodash/groupBy'
import compact from 'lodash/compact'
import isNull from 'lodash/isNull'
import isEmpty from 'lodash/isEmpty'

export function mobileCheck() {
  let check = false
  ;(function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)
  return check
}

export function sortByDate(arr, direction = 'asc', column = 'proposal_at') {
  if (direction === 'asc') {
    arr.sort((a, b) => new Date(a[column]) - new Date(b[column]))
  } else {
    arr.sort((a, b) => new Date(b[column]) - new Date(a[column]))
  }

  return arr
}

export function sortByString(arr, direction = 'asc', column = 'deadline_at') {
  if (direction === 'asc') {
    arr.sort((a, b) => ('' + b[column]).localeCompare(a[column]))
  } else {
    arr.sort((a, b) => ('' + a[column]).localeCompare(b[column]))
  }

  return arr
}

export function sort(arr, key, direction = 'asc') {
  if (direction === 'asc') {
    arr.sort((a, b) => a[key] - b[key])
  } else {
    arr.sort((a, b) => b[key] - a[key])
  }

  return arr
}

export function objToQueryString(obj) {
  let str = []
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
    }
  return str.join('&')
}

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export function mergeDataByGroup(data) {
  const result = []

  const defaultKey = 999

  /* Merge data by meta_group_id */
  const tmp = groupBy(data, item => item?.meta_group_id || null)

  /* Sort data by meta_group_id */
  Object.values(tmp).map(value => {
    const item = []
    item.push(...value)

    const key = item[0].meta_group_id || defaultKey

    result[key] = {
      index: key,
      group_name: item[0].group?.name,
      layout: parseInt(item[0]?.pivot?.layout) || 2,
      items: item,
    }
  })

  return compact(result)
}

export function basename(str, sep = '/') {
  return str.substr(str.lastIndexOf(sep) + 1)
}

export function uuid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
  )
}

export function parseFilter(str) {
  const filter = str.match(/\[(.+)=(.+)\]/)

  return filter
    ? {
        selector: str.slice(0, filter.index),
        key: filter[1],
        val: /^\d+$/.test(filter[2]) ? parseInt(filter[2], 10) : filter[2],
      }
    : null
}

export function filterColl(coll, filter) {
  if (Array.isArray(coll)) {
    return coll.filter(item => item[filter.key] === filter.val)
  }

  return coll[filter.key] === filter.val ? coll : null
}

export function pluckDeepWithSelectors(coll, selectors) {
  // No more selectors
  if (!selectors.length) {
    return coll
  }

  // Pluck the current value from the given selector
  let sel = selectors[0]

  let filtered = coll

  // Filter if applicable
  const filter = parseFilter(sel)

  if (filter) {
    filtered = filterColl(coll, filter)

    if (!filtered || (Array.isArray(filtered) && !filtered.length)) {
      return null
    }

    sel = filter.selector
  }

  const p = pluck(filtered, sel)

  // No values found for current selector
  if (isUndefined(p) || (Array.isArray(p) && p.some(isUndefined))) {
    return null
  }

  // Recursively call with the remaining selectors
  return pluckDeepWithSelectors(p, selectors.slice(1))
}

export function pluckDeep(obj, keys, delimiter = '.') {
  keys = keys.split(delimiter).map(item => item.trim())
  return pluckDeepWithSelectors(obj, keys)
}

export function pluckJoin(arr, data, delimiter = ', ') {
  try {
    const result = []

    arr.map(item => {
      result.push(data[item])
    })

    return result.join(delimiter)
  } catch (e) {
    console.log(e)
    return null
  }
}

export function objectToListOptions(object, integer = true, key = 'value', label = 'label') {
  return Object.keys(object).map(objectKey => ({
    [key]: integer ? parseInt(objectKey) : objectKey,
    [label]: object[objectKey],
  }))
}

export function pluck(data, key) {
  return Array.isArray(data) ? data.map(item => item[key]) : []
}

// Delete empty property from the array
export function arrayFilter(arr) {
  return arr.filter(Boolean)
}

// Limit array
export function limit(arr, limit, start = 0) {
  return arr.splice(start, limit)
}

// Random string
export function randomString(chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', length = 16) {
  return Array(length)
    .fill('')
    .map(v => chars[Math.floor(Math.random() * chars.length)])
    .join('')
}

export function addslashes(str) {
  return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0')
}

export function numberFormat(number, decimals = null, dec_point = '.', thousands_sep = ',') {
  // Strip all characters but numerical ones.
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '')

  let n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = (n, prec) => {
      const k = Math.pow(10, prec)
      return '' + Math.round(n * k) / k
    }

  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (isNull(decimals) ? '' + n : prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')

  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }

  return s.join(dec)
}

export function convertPHPToMomentFormat(phpFormat) {
  const replacements = {
    d: 'DD',
    D: 'ddd',
    j: 'D',
    l: 'dddd',
    N: 'E',
    S: 'o',
    w: 'e',
    z: 'DDD',
    W: 'W',
    F: 'MMMM',
    m: 'MM',
    M: 'MMM',
    n: 'M',
    t: '', // no equivalent
    L: '', // no equivalent
    o: 'YYYY',
    Y: 'YYYY',
    y: 'YY',
    a: 'a',
    A: 'A',
    B: '', // no equivalent
    g: 'h',
    G: 'H',
    h: 'hh',
    H: 'HH',
    i: 'mm',
    s: 'ss',
    u: 'SSS',
    e: 'zz', // deprecated since version 1.6.0 of moment.js
    I: '', // no equivalent
    O: '', // no equivalent
    P: '', // no equivalent
    T: '', // no equivalent
    Z: '', // no equivalent
    c: '', // no equivalent
    r: '', // no equivalent
    U: 'X',
  }

  // Converts escaped characters.
  Object.entries(replacements).forEach(([key]) => {
    replacements['\\' + key] = '[' + key + ']'
  })

  return phpFormat
    .split('')
    .map(chr => (chr in replacements ? replacements[chr] : chr))
    .join('')
}

export function countDayByMonth(month = null, year = null) {
  if (!month) {
    return 31
  }

  let day

  // TODO: Need optimize
  switch (month) {
    case 1:
    case 3:
    case 5:
    case 7:
    case 8:
    case 10:
    case 12:
      day = 31
      break
    case 4:
    case 6:
    case 9:
    case 11:
      day = 30
      break
    case 2:
      if (isEmpty(year)) {
        day = 29
        break
      }

      if (year % 100 !== 0 && year % 4 === 0) {
        day = 29
      } else {
        day = 28
      }
      break
    default:
      day = 0
  }

  return day
}

function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    var successful = document.execCommand('copy')
    var msg = successful ? 'successful' : 'unsuccessful'
    console.log('Fallback: Copying text command was ' + msg)
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
  }

  document.body.removeChild(textArea)
}

export function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
    return
  }
  navigator.clipboard.writeText(text).then(
    function() {
      console.log('Async: Copying to clipboard was successful!')
    },
    function(err) {
      console.error('Async: Could not copy text: ', err)
    },
  )
}

export function getListCounter(index, type, pattern) {
  switch (type) {
    case 'bullet':
      return '•'
    case 'number':
      return index + '.'
    case 'alpha':
      return toAlpha(index) + '.'
    case 'roman':
      return toRoman(index) + '.'
    case 'custom':
      return pattern.replace(':number:', index)
  }

  return ''
}

function toAlpha(num) {
  let s = '',
    t

  while (num > 0) {
    t = (num - 1) % 26
    s = String.fromCharCode(65 + t) + s
    num = ((num - t) / 26) | 0
  }
  return s || undefined
}

function toRoman(num) {
  if (isNaN(num)) return NaN
  let digits = String(+num).split(''),
    key = [
      '',
      'C',
      'CC',
      'CCC',
      'CD',
      'D',
      'DC',
      'DCC',
      'DCCC',
      'CM',
      '',
      'X',
      'XX',
      'XXX',
      'XL',
      'L',
      'LX',
      'LXX',
      'LXXX',
      'XC',
      '',
      'I',
      'II',
      'III',
      'IV',
      'V',
      'VI',
      'VII',
      'VIII',
      'IX',
    ],
    roman = '',
    i = 3
  while (i--) roman = (key[+digits.pop() + i * 10] || '') + roman
  return Array(+digits.join('') + 1).join('M') + roman
}

export const range = function (start, end, step = 1) {
  let output = [];
  if (typeof end === 'undefined') {
    end = start;
    start = 0;
  }
  for (let i = start; i < end; i += step) {
    output.push(i);
  }
  return output;
};

export const getCurrentYear = () => {
  return new Date().getFullYear();
}

export const randomInRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export const isPublicRoute = (url) => {
  const publicPaths =[
    '/contact',
    '/contact-application',
    '/contact-complete-application',
    '/contact-complete',
    '/news',
    '/post',
    '/privacy',
    '/resources',
    '/resources-complete',
    '/terms',
    '/trade',
    '/',
    '/lp/*',
    '/landing/*'
  ];

  const regexPatterns = publicPaths.map(path => {
    const regexPattern = path.replace(/\*/g, '.*');
    return new RegExp(`^${regexPattern}$`);
  });

  return regexPatterns.some(regex => regex.test(url));
};